module.exports = __webpack_public_path__ + "img/PriceQuotations_FinishJobOrderNotCustomerReceive.7f9145e2.svg";